<template>
  <div class="tree-choice-container">
    <div class="tree-choice-content">
      <div
        v-for="node of treeData"
        :key="node[props.value]"
        @click.stop="chooseNode(node)"
        :class="{
          'tree-choice': true,
          'current': chooseList.includes(node[props.value])
        }">
        <node-content :node="node"></node-content>
      </div>
    </div>
    <template v-if="children && children.length">
      <tree-node
        :props="props"
        :treeData="children"
        :chooseList="chooseList">
      </tree-node>
    </template>
  </div>
</template>

<script>
export default {
  name: 'tree-node',
  components: {
    'node-content': {
      props: {
        node: {
          type: Object,
          required: true
        }
      },
      render (h) {
        const tree = this.$parent.tree
        const titleKey = this.$parent.props.title
        const node = this.node
        return tree.$scopedSlots.default ? tree.$scopedSlots.default({ node }) : <div>{ node[titleKey] }</div>
      }
    }
  },
  props: {
    treeData: {
      type: Array,
      required: true
    },
    chooseList: {
      type: Array,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      level: 0,
      tree: null
    }
  },
  computed: {
    children () {
      const parentValue = this.chooseList[this.level - 1]
      if (!parentValue) return 0
      const parentData = this.treeData.find(data => data[this.props.value] === parentValue)
      if (!parentData) return 0
      return parentData[this.props.children]
    }
  },
  created () {
    const parent = this.$parent
    if (parent.isTree) {
      this.level = 1
      this.tree = parent
    } else {
      this.level = parent.level + 1
      this.tree = parent.tree
    }
  },
  methods: {
    chooseNode (node) {
      this.tree.$emit('choose-node', node)
    }
  }
}
</script>

<style lang="stylus" scoped>
.tree-choice-container
  display flex
  .tree-choice-content
    overflow-y auto
    border-right 1px solid #DFDFDF
    width 3rem
    min-width 3rem
    .tree-choice
      padding 4px 8px
      border-bottom 1px solid #DFDFDF
      display flex
      justify-content space-between
      &:hover
        cursor pointer
        background #B0C8F4
      &.current
        color white
        background #3361D8

</style>
